//empty link with empty content removal
$(document).ready(function() {
  $('a').each(function() {
    var linkText = $(this).text().trim();
    var linkHtml = $(this).html().trim();
    
    if (linkText === '' && linkHtml === '') {
      $(this).remove();
    }
  });
  $('.site-nav__link.site-nav__link--underline:not(.site-nav__link--has-dropdown) svg').remove();
  $('br').attr('aria-hidden','true');
  $(' h2, h3, h4, h5, h6').each(function () {
    if ($(this).text().trim() === '') {
      $(this).remove();
    }
  });
  setInterval(() => {
    $('.flickity-enabled.is-draggable.is-fade').removeAttr('tabindex','0');
  }, 500);
});

//empty link with content into div
// $(document).ready(function() {
//     $('a').each(function() {
//       var $a    = $(this);
//       var href  = $a.attr('href');
//       if (!href || $.trim(href) === '') {
//         var $div = $('<div>');
//         $.each(this.attributes, function() {
//           if (this.name.toLowerCase() !== 'href') {
//             $div.attr(this.name, this.value);
//           }
//         });
//         $div.html($a.html());
//         $a.replaceWith($div);
//       }
//     });
//   });
  

  $(document).ready(function () {
    setInterval(() => {
      $('.product-slideshow').removeAttr('tabindex','0');
    }, 500);
    $('.noUi-handle.noUi-handle-lower').attr('aria-label','minimum price, after updation, the price will be increased by 10 and focus goes out of filters');
    $('.noUi-handle.noUi-handle-upper').attr('aria-label','maximum price, after updation, the price will be decreased by 10 and focus goes out of filters');
  });


//External warning
  document.querySelectorAll('a[href]').forEach(link => {
    const href = link.getAttribute('href')?.trim();
   
    // Skip if no href
    if (!href) return;
   
    // Skip mailto: and tel:
    if (href.startsWith('mailto:') || href.startsWith('tel:')) return;
   
    try {
      // Create absolute URL based on current site
      const linkUrl = new URL(href, window.location.origin);
      const isExternal = linkUrl.origin !== window.location.origin;
   
      if (isExternal) {
        const label = link.getAttribute('title')?.trim() || link.textContent.trim();
   
        if (label && !link.hasAttribute('aria-label')) {
          link.setAttribute('aria-label', `${label} (opens in a new window)`);
        }
   
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
      }
    } catch (error) {
      // Catch invalid href like "#", javascript:void(0), etc.
      return;
    }
  });
   
  
//mail and phone number warnings
document.querySelectorAll('a[href^="mailto:"], a[href^="tel:"]').forEach(link => {
  const href = link.getAttribute('href')?.trim();
 
  if (!href) return;
 
  const labelText = link.getAttribute('title')?.trim() || link.textContent.trim();
  const fallback = href.replace(/^mailto:|^tel:/, ''); // remove tel: or mailto:
 
  if (href.startsWith('mailto:') && !link.hasAttribute('aria-label')) {
    link.setAttribute('aria-label', `Email: ${labelText || fallback}`);
  }
 
  if (href.startsWith('tel:') && !link.hasAttribute('aria-label')) {
    link.setAttribute('aria-label', `Phone: ${labelText || fallback}`);
  }
});

// Dropdown menu code
$(document).ready(function() {
  let hoverTimeout;
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  let lastTrigger = null;

  // Accessibility setup - Keep links accessible
  $('.site-nav__link--has-dropdown').each(function() {
    $(this).attr({
      'aria-haspopup': 'true',
      'aria-expanded': 'false'
    });
  });

  // Desktop Hover Functionality
  if (!isTouchDevice) {
    $('.site-nav__item.site-nav--has-dropdown').hover(
      function() {
        clearTimeout(hoverTimeout);
        const $item = $(this);
        
        // Close all other dropdowns
        $('.site-nav__item').removeClass('is-focused is-hovered');
        $('.site-nav__link--has-dropdown').attr('aria-expanded', 'false');
        
        // Open this dropdown
        $item.addClass('is-hovered');
        $item.find('.site-nav__link--has-dropdown').attr('aria-expanded', 'true');
      },
      function() {
        const $item = $(this);
        hoverTimeout = setTimeout(() => {
          $item.removeClass('is-hovered');
          $item.find('.site-nav__link--has-dropdown').attr('aria-expanded', 'false');
        }, 300);
      }
    );

    // Keep dropdown open when moving to it
    $('.site-nav__dropdown, .megamenu').hover(
      () => clearTimeout(hoverTimeout),
      function() {
        const $item = $(this).closest('.site-nav__item');
        $item.removeClass('is-hovered');
        $item.find('.site-nav__link--has-dropdown').attr('aria-expanded', 'false');
      }
    );
  }

  // Click/Tap Functionality for all devices
  $('.site-nav__link--has-dropdown').on('click keydown', function(e) {
    if (e.type === 'keydown' && ![13, 32].includes(e.which)) return;
    if (!isTouchDevice && e.type === 'click') return; // Skip click on desktop
    
    e.preventDefault();
    const $trigger = $(this);
    const $parentItem = $trigger.closest('.site-nav__item');
    const wasExpanded = $trigger.attr('aria-expanded') === 'true';
    
    // Close all other dropdowns
    $('.site-nav__item').removeClass('is-focused is-hovered');
    $('.site-nav__link--has-dropdown').attr('aria-expanded', 'false');
    
    if (!wasExpanded) {
      $parentItem.addClass('is-focused');
      $trigger.attr('aria-expanded', 'true');
      lastTrigger = $trigger;
    }
  });

  // Close dropdowns when clicking outside
  $(document).on('click', function(e) {
    if (!$(e.target).closest('.site-nav__item').length) {
      $('.site-nav__item').removeClass('is-focused is-hovered');
      $('.site-nav__link--has-dropdown').attr('aria-expanded', 'false');
    }
  });

  // Close on Escape key
  $(document).on('keydown', function(e) {
    if (e.key === 'Escape') {
      $('.site-nav__item').removeClass('is-focused is-hovered');
      $('.site-nav__link--has-dropdown').attr('aria-expanded', 'false');
      if (lastTrigger) lastTrigger.focus();
    }
  });
});


 // Country Selector
$(document).ready(function () {
  var $switcher = $('.plus-store-switcher');
  var $toggle = $switcher.find('.plus-store-switcher__toggle, [data-dropdown-toggle]');
  var $content = $switcher.find('[data-dropdown-content]');

  function setExpanded(isOpen) {
    $toggle.attr('aria-expanded', isOpen);
    $content.attr('aria-hidden', !isOpen);
  }

  $(document).on('click', function (e) {
    var $target = $(e.target);
    var $inSwitcher = $target.closest('.plus-store-switcher');
    var $clickedToggle = $target.closest('.plus-store-switcher__toggle, [data-dropdown-toggle]');

    if ($clickedToggle.length) {
      var willOpen = !$switcher.hasClass('site-nav--active-dropdown');
      $switcher.toggleClass('site-nav--active-dropdown', willOpen);
      setExpanded(willOpen);
    } else if (!$inSwitcher.length) {
      if ($switcher.hasClass('site-nav--active-dropdown')) {
        $switcher.removeClass('site-nav--active-dropdown');
        setExpanded(false);
      }
    }
  });

  $toggle.on('keydown', function (e) {
    if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault();
      var willOpen = !$switcher.hasClass('site-nav--active-dropdown');
      $switcher.toggleClass('site-nav--active-dropdown', willOpen);
      setExpanded(willOpen);
    }
  });
});

// Country Selector Escape Handler
document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
        const switcher = document.querySelector('.plus-store-switcher.site-nav--active-dropdown');
        if (!switcher) return;
        const toggle = switcher.querySelector('.plus-store-switcher__toggle, [data-dropdown-toggle]');
        const content = switcher.querySelector('[data-dropdown-content]');
        switcher.classList.remove('site-nav--active-dropdown');
        toggle.setAttribute('aria-expanded', 'false');
        content.setAttribute('aria-hidden', 'true');
        toggle.focus();
    }
});


//Slider video button popup
let lastFocusedElement = null;
let focusableElements = [];

function openPopup(videoSrc) {
  const popup = document.getElementById("videoPopup");
  const popupIframe = document.getElementById("popupIframe");
  
  lastFocusedElement = document.activeElement;
  
  popup.style.display = "flex";
  popup.setAttribute('aria-hidden', 'false');
  
  popupIframe.src = videoSrc;
  
  focusableElements = Array.from(popup.querySelectorAll(
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
  ));
  
  if (focusableElements.length > 0) {
    setTimeout(() => focusableElements[0].focus(), 50);
  }
  
  document.addEventListener('keydown', handlePopupKeys);
  popupIframe.setAttribute('tabindex', '-1');
}

function closePopup() {
  const popup = document.getElementById("videoPopup");
  const popupIframe = document.getElementById("popupIframe");
  
  popup.style.display = "none";
  popup.setAttribute('aria-hidden', 'true');

  popupIframe.src = '';

  if (lastFocusedElement) {
    lastFocusedElement.focus();
  }

  document.removeEventListener('keydown', handlePopupKeys);
}
function handlePopupKeys(event) {
  const popup = document.getElementById("videoPopup");
  if (popup.style.display !== "flex") return;
  if (event.key === 'Escape') {
    closePopup();
    event.preventDefault();
    return;
  }
  if (event.key === 'Tab') {
    if (focusableElements.length === 0) return;
    
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (event.shiftKey) {
      if (document.activeElement === firstElement) {
        lastElement.focus();
        event.preventDefault();
      }
    } else {
      if (document.activeElement === lastElement) {
        firstElement.focus();
        event.preventDefault();
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const popup = document.getElementById("videoPopup");
  popup.style.display = "none";
  popup.setAttribute('role', 'dialog');
  popup.setAttribute('aria-modal', 'true');

  popup.addEventListener('click', function(event) {
    if (event.target === this) {
      closePopup();
    }
  });
});


//iframe for missing title
$(document).ready(function() {
  $('iframe:not([title])').each(function() {
    var $iframe = $(this);
    var src = $iframe.attr('src') || '';

    // Match by common sources
    if (src.includes('youtube.com') || src.includes('youtu.be')) {
      $iframe.attr('title', 'YouTube video');
    } else if (src.includes('vimeo.com')) {
      $iframe.attr('title', 'Vimeo video');
    } else if (src.includes('maps.google.com') || src.includes('google.com/maps')) {
      $iframe.attr('title', 'Google Map');
    } else if (src.includes('player.soundcloud.com')) {
      $iframe.attr('title', 'SoundCloud audio player');
    } else if (src.includes('facebook.com')) {
      $iframe.attr('title', 'Facebook embedded content');
    } else {
      $iframe.attr('title', 'Embedded content');
    }
  });
});